/* eslint-disable react/no-danger, react/forbid-prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import {css} from '@emotion/react'
import Img from 'gatsby-image'
import {createMarkup} from '../util/datoCmsDataFactory'

const SideBySide = ({
    imageSrc,
    gatsbyImage,
    title,
    description, // this will be an html string
    imagePosition, // left|right
    overrideStyles,
}) => {
    return (
        <div
            className="side-by-side"
            css={css`
                display: flex;
                flex-direction: ${imagePosition === 'left' ? 'row' : 'row-reverse'};
                align-items: center;
                padding: 2rem;
                h3 {
                    margin: 0 0 1rem;
                }
                img {
                    padding: ${imagePosition === 'left' ? '0 2rem 0 0' : '0 0 0 2rem'};
                }
                ${overrideStyles}
            `}
        >
            {imageSrc && <img src={imageSrc} alt="privacy-icon" className="side-by-side-image" />}
            {gatsbyImage && <Img fixed={gatsbyImage} />}
            <div className="side-by-side-text">
                <h3>{title}</h3>
                <div dangerouslySetInnerHTML={createMarkup(description)} />
            </div>
        </div>
    )
}

SideBySide.propTypes = {
    imageSrc: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    imagePosition: PropTypes.string,
    overrideStyles: PropTypes.any,
}

export default SideBySide
